module.exports = __webpack_public_path__ + "static/media/banner-nao-logado-desktop-1.6c476268.webp";